/* Empty file do not delete */
module.exports = {
    image0: ""
}